import { render } from "./DevicesForm.vue?vue&type=template&id=637d87b4"
import script from "./DevicesForm.vue?vue&type=script&lang=js"
export * from "./DevicesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__